import { Share2 } from 'lucide-react';
import type { BusinessReferral } from '../../types/businessMetrics';
import { formatBusinessCount } from '../../types/businessMetricsView';
import { BusinessPanel, NoDataNote, StatGrid, StatTile } from './businessPanelParts';

export function ReferralPanel({ referral }: { referral: BusinessReferral }) {
  return (
    <BusinessPanel title="추천" testId="business-referral-panel" icon={Share2}>
      {referral.status === 'NOT_AVAILABLE' ? (
        <NoDataNote message={referral.message} />
      ) : (
        <div className="space-y-2">
          <StatGrid>
            <StatTile label="발급 코드" value={formatBusinessCount(referral.codesIssued)} />
            <StatTile label="추천 가입" value={formatBusinessCount(referral.signups)} />
            <StatTile label="확정" value={formatBusinessCount(referral.confirmed)} />
            <StatTile label="취소" value={formatBusinessCount(referral.canceled)} />
            <StatTile label="보상 대기" value={formatBusinessCount(referral.rewardsPending)} />
            <StatTile label="보상 지급" value={formatBusinessCount(referral.rewardsPaid)} />
          </StatGrid>
          {referral.message ? <p className="text-xs text-muted-foreground">{referral.message}</p> : null}
        </div>
      )}
    </BusinessPanel>
  );
}
